// packages import
import { Autocomplete, TextField } from '@mui/material'
import { FC, useContext } from 'react'

// others
import { FinalBillsContext } from '../../../../context/FinalBillsContext'

interface SentStatusOption {
  value: boolean | 'all'
  label: string
}

const sentStatusOptions: SentStatusOption[] = [
  { value: 'all', label: 'All' },
  { value: true, label: 'Sent to Client' },
  { value: false, label: 'Not Sent' }
]

const SentStatusFilter: FC = () => {
  const { filters, setFilters } = useContext(FinalBillsContext)

  // undefined filter => "All". Note: `false` is a real value, so guard on undefined explicitly.
  const current: boolean | 'all' = filters.sentStatus === undefined ? 'all' : filters.sentStatus
  const selected = sentStatusOptions.find(option => option.value === current) || null

  const handleChange = (value: SentStatusOption | null) => {
    // "All" (or cleared) means no filter — drop the param entirely.
    setFilters({ sentStatus: value && typeof value.value === 'boolean' ? value.value : undefined })
  }

  return (
    <Autocomplete
      sx={{ minWidth: 160 }}
      options={sentStatusOptions}
      value={selected}
      onChange={(_, value) => handleChange(value)}
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={params => <TextField {...params} label="Delivery Status" />}
    />
  )
}

export default SentStatusFilter
